import axios from "axios";
import { CONSTS } from "src/consts/consts";

const mainUrl                          = process.env.REACT_APP_MAIN_URL;
const GET_ALL_WORKER_DEMANDERS_API_URL = mainUrl + CONSTS.WORKER_DEMANDER_GET_ALL;
const GET_ALL_WORKER_DEMANDERS_ASYNC_API_URL = mainUrl + CONSTS.WORKER_DEMANDER_GET_ALL_ASYNC;
const GET_WITH_EXTRA_WORKER_DEMANDER_ASYNC_API_URL = mainUrl + CONSTS.WORKER_DEMANDER_GET_WITH_EXTRA_ASYNC;
const GET_UNPLANNED_WORK_REQUESTS_API_URL =mainUrl + CONSTS.WORKER_DEMANDER_GET_UNPLANNED_WORK_REQUESTS_ASYNC;
const GET_WORK_REQUEST_API_URL =mainUrl + CONSTS.WORKER_DEMANDER_GET_WORK_REQUEST_ASYNC;

const WORKER_DEMANDER_REQUEST_A_WORK_ASYNC_API_URL = mainUrl + CONSTS.WORKER_DEMANDER_REQUEST_A_WORK_ASYNC;
const REGISTER_WORKER_DEMANDER_API_URL =mainUrl + CONSTS.WORKER_DEMANDER_REGISTER;

const UPDATE_WORKER_DEMANDER_REQUEST_A_WORK_ASYNC_API_URL = mainUrl + CONSTS.WORKER_DEMANDER_UPDATE_ASYNC;
const UPDATE_WORK_REQUEST_ASYNC_API_URL = mainUrl + CONSTS.WORKER_DEMANDER_UPDATE_WORK_REQUEST_ASYNC;



export const WorkerDemanderService = {
  GET_WORKER_DEMANDERS: () => {
    var filter = { isRegisteredFilterActive : true, isRegistered : false }
      return axios.post(GET_ALL_WORKER_DEMANDERS_ASYNC_API_URL, filter);
  },
  GET_WORKER_DEMANDERS_ASYNC: async() => { 
    var filter = { isRegisteredFilterActive : false}
      return await axios.post(GET_ALL_WORKER_DEMANDERS_ASYNC_API_URL,filter);
  },
  GET_WORKER_DEMANDERS_WITH_EXTRA_ASYNC: async(workerDemanderId) => { 
      return await axios.get(GET_WITH_EXTRA_WORKER_DEMANDER_ASYNC_API_URL+`?workerDemanderId=${workerDemanderId}`);
  },


  GET_REGISTERED_CLIENTS: () => {
    var filter = { isRegisteredFilterActive : true, isRegistered : true }
    return axios.post(GET_ALL_WORKER_DEMANDERS_ASYNC_API_URL, filter);
  },

  SAVE_REQUEST_A_WORK: async (newWorkerDemander) => {
    return await axios.post(WORKER_DEMANDER_REQUEST_A_WORK_ASYNC_API_URL, newWorkerDemander);

  },  
  UPDATE_WORKER_DEMANDER_REGISTER_FORM: async (workerDemanderId,newWorkerDemander) => { 
  
    return  await axios.post(UPDATE_WORKER_DEMANDER_REQUEST_A_WORK_ASYNC_API_URL+`?workerDemanderId=${workerDemanderId}`, newWorkerDemander);
  },
  GET_UNPLANNED_WORK_REQUESTS: async(workerDemanderId) => { 
      return await axios.get(GET_UNPLANNED_WORK_REQUESTS_API_URL+`?workerDemanderId=${workerDemanderId}`);
  },
  REGISTER_WORKERDEMANDER: async(workerDemanderId) => {  
    return await axios.post(REGISTER_WORKER_DEMANDER_API_URL+`?workerDemanderId=${workerDemanderId}`);
  },
  GET_WORK_REQUEST_ASYNC: async(workRequestId) => { 
    return await axios.get(GET_WORK_REQUEST_API_URL+`?workRequestId=${workRequestId}`);
},
 UPDATE_WORK_REQUEST_ASYNC: async (workRequestId,newWorkerDemander) => { 
  
  return  await axios.post(UPDATE_WORK_REQUEST_ASYNC_API_URL+`?workRequestId=${workRequestId}`, newWorkerDemander);
},

   
};
